/**
 * Language utilities for settings
 */

export interface Language {
  value: string
  label: string
}

export const LANGUAGES: Language[] = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
]

export function getLanguages(): Language[] {
  return LANGUAGES
}
